<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  <ul class="list-unstyled">
    @for (p of body; track p) {
      <li>
        @if (p.startsWith('{') || p.startsWith('[')) {
          <!--  Json  -->
          <pre>{{ p }}</pre>
        } @else {
          {{ p }}
        }
      </li>
    }
  </ul>
</div>
<div class="modal-footer">
  <div class="col"></div>
  <button type="button" class="btn btn-outline-primary" (click)="modal.close()">OK</button>
</div>
